import { ActiveToast, Toast, ToastrConfig } from 'ngx-toastr';
import { Injectable } from '@angular/core';

export interface ZoneAwareParsedError {
  message: string;
  toastConfig: ToastrConfig;
}

@Injectable()
export class ZoneAwareErrorDetectionService {
  private zoneAwareParsedError: ZoneAwareParsedError = <ZoneAwareParsedError>{};

  public parseError(error: any): ZoneAwareParsedError {
    if (this.isZoneAwareError(error)) {

      // Set a special-case ToastConfig.
      this.zoneAwareParsedError.toastConfig = {
        disableTimeOut: false,
        easeTime: 300,
        easing: 'ease-in',
        progressAnimation: 'decreasing',
        progressBar: false,
        enableHtml: true,
        messageClass: 'toast-message',
        onActivateTick: false,
        tapToDismiss: true,
        timeOut: 0,
        titleClass: 'toast-title',
        toastClass: 'toast',
        extendedTimeOut: 0,
        closeButton: true,
        positionClass: 'toast-top-center'
      };

      // Set the toast message when the error is a ZoneAwareError.
      this.zoneAwareParsedError.message =
        'Please <b>click here</b> to login to the application with your newly created username and password.';
    }

    return this.zoneAwareParsedError;
  }

  public isZoneAwareError(error: any): boolean {
    const zoneSymbolErrorText: string = '__zone_symbol__error';
    const zoneAwareErrorText: string = 'ZoneAwareError';
    let errorIsZoneAwareError: boolean = false;

    // Sniff the error for ZoneAwareError-specific text.
    if (
      typeof error === 'string' &&
      (error.indexOf(zoneSymbolErrorText) > -1 ||
      error.indexOf(zoneAwareErrorText) > -1)
    ) {
      errorIsZoneAwareError = true;
    } else if (
      error[zoneSymbolErrorText] ||
      error.originalStack &&
      error.originalStack.indexOf(zoneAwareErrorText) > -1
    ) {
      errorIsZoneAwareError = true;
    }

    return errorIsZoneAwareError;
  }
}
